/**
 * Module-level configuration for `OnlineMenuHost` — transport URL, storage key,
 * and the two seat constants. Split out to keep the host class itself under the
 * 200-line limit; it holds behaviour, this holds the values it reads once.
 */

import { MAHJONG_TABLE_SEATS, clampHumanSeats } from '../network/roomOptions.js';

/**
 * Dev default. Production reads `VITE_WS_SERVER_URL`, which the combined build
 * derives from the one `VITE_WS_BASE_URL` knob.
 */
const DEV_WS_URL = 'ws://localhost:3001/ws/mahjong';

export const SESSION_STORAGE_KEY = 'mahjong.online.session';

/**
 * A Discord instance room holds the MAXIMUM humans — `clampHumanSeats`'s upper
 * bound — so everyone launching the activity in the channel gets a seat and
 * nobody is turned away as `ROOM_FULL`. The host can still start whenever they
 * like: `allowEarlyStart` shrinks the room to occupancy and bots the rest.
 */
export const DISCORD_HUMAN_SEATS = clampHumanSeats(MAHJONG_TABLE_SEATS);

/** The one seat the server accepts `START_GAME` from. */
export const HOST_SEAT = 0;

export function resolveServerUrl(): string {
  const configured = import.meta.env['VITE_WS_SERVER_URL'] as string | undefined;
  return configured !== undefined && configured !== '' ? configured : DEV_WS_URL;
}

/** Dev default — production reads `VITE_LOBBY_WS_URL`, set by the combined
 * build from the same `VITE_WS_BASE_URL` knob `resolveServerUrl` uses. */
const DEV_LOBBY_WS_URL = 'ws://localhost:3001/ws/lobby';

export function resolveLobbyServerUrl(): string {
  const configured = import.meta.env['VITE_LOBBY_WS_URL'] as string | undefined;
  return configured !== undefined && configured !== '' ? configured : DEV_LOBBY_WS_URL;
}
